import { Globe2 } from "lucide-react";
import { Reveal, SectionTag, TituloLineas } from "@/components/Reveal";
import BoliviaMapa from "@/components/BoliviaMapa";

export default function Demos() {
  return (
    <section id="demos" className="scroll-mt-20 bg-abyss px-4 py-20 sm:px-8 lg:px-12 lg:py-32">
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <Reveal>
            <SectionTag>Demos y entregas</SectionTag>
            <TituloLineas
              lineas={["Vamos donde", "está su cultivo"]}
              className="mt-5 max-w-2xl font-display text-2xl font-bold uppercase leading-tight tracking-tight text-mist sm:text-3xl lg:text-4xl"
            />
          </Reveal>
          <Reveal delay={0.15}>
            <p className="max-w-md text-sm leading-relaxed text-smoke lg:text-right">
              Elija un departamento o toque un punto del mapa para ver la zona y reservar su
              demostración.
            </p>
          </Reveal>
        </div>

        <div className="mt-14" data-testid="demo-map-real">
          <BoliviaMapa />
        </div>

        <Reveal delay={0.2}>
          <p className="mt-8 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-smoke/70">
            <Globe2 className="h-3.5 w-3.5" /> Nuevas demostraciones y entregas se anuncian aquí y por WhatsApp.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
